var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoralReef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 106.879,
    y2: 593.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 314.642,
    y2: 434.674
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.501,
    x2: 209.063,
    xlinkHref: "#lg2",
    y1: 366.163,
    y2: 228.433
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.562,
    x2: 371.562,
    xlinkHref: "#lg2",
    y1: 386.806,
    y2: 272.806
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.877,
    x2: 426.877,
    xlinkHref: "#lg2",
    y1: 231.155,
    y2: 150.155
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-.933 -.361 -.361 .933 996.116 186.21)",
    gradientUnits: "userSpaceOnUse",
    x1: 582.079,
    x2: 699.079,
    xlinkHref: "#lg2",
    y1: 364.811,
    y2: 283.811
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.572,
    x2: 269.472,
    xlinkHref: "#lg3",
    y1: 320.193,
    y2: 320.193
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.542,
    x2: 288.956,
    xlinkHref: "#lg3",
    y1: 284.169,
    y2: 284.169
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.855,
    x2: 390.855,
    xlinkHref: "#lg3",
    y1: 157.413,
    y2: 307.413
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.945,
    x2: 367.945,
    xlinkHref: "#lg3",
    y1: 172.075,
    y2: 322.075
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.478,
    x2: 123.067,
    xlinkHref: "#lg3",
    y1: 177.131,
    y2: 177.131
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.183,
    x2: 212.183,
    xlinkHref: "#lg3",
    y1: 166.533,
    y2: 279.533
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.83,
    x2: 290.83,
    xlinkHref: "#lg3",
    y1: 115.06,
    y2: 173.06
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.063,
    x2: 199.063,
    xlinkHref: "#lg3",
    y1: 175.241,
    y2: 288.241
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.7,
    x2: 467.7,
    xlinkHref: "#lg3",
    y1: 216.916,
    y2: 254.916
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#fc482b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.723 -.691 -.691 .723 866.903 1229.93)",
    gradientUnits: "userSpaceOnUse",
    x1: 967.432,
    x2: 976.099,
    xlinkHref: "#lg4",
    y1: -365.522,
    y2: -356.855
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.094 -.996 -.996 -.094 777.911 1561.633)",
    gradientUnits: "userSpaceOnUse",
    x1: 1171.152,
    x2: 1179.819,
    xlinkHref: "#lg4",
    y1: 544.773,
    y2: 553.44
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.249 .969 -.969 .249 720.975 980.495)",
    gradientUnits: "userSpaceOnUse",
    x1: -769.117,
    x2: -760.45,
    xlinkHref: "#lg4",
    y1: 168.643,
    y2: 177.31
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.249 .969 -.969 .249 720.975 980.495)",
    gradientUnits: "userSpaceOnUse",
    x1: -772.246,
    x2: -763.579,
    xlinkHref: "#lg4",
    y1: 238.652,
    y2: 247.319
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.835 .55 -.55 .835 523.227 929.471)",
    gradientUnits: "userSpaceOnUse",
    x1: -487.521,
    x2: -478.854,
    xlinkHref: "#lg4",
    y1: -530.45,
    y2: -521.782
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.302,
    x2: 222.302,
    xlinkHref: "#lg2",
    y1: 169.535,
    y2: 361.535
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(.417 -.909 .909 .417 -166.499 1400.318)",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.446,
    x2: 1164.113,
    xlinkHref: "#lg4",
    y1: -204.67,
    y2: -196.002
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-.455 -.891 .891 -.455 38.53 1675.834)",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.083,
    x2: 1178.75,
    xlinkHref: "#lg4",
    y1: 796.952,
    y2: 805.619
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.126 .992 .992 -.126 -122.827 1114.651)",
    gradientUnits: "userSpaceOnUse",
    x1: -836.041,
    x2: -827.373,
    xlinkHref: "#lg4",
    y1: 404.41,
    y2: 413.077
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(-.574 .819 .819 .574 42.174 994.307)",
    gradientUnits: "userSpaceOnUse",
    x1: -695.54,
    x2: -686.873,
    xlinkHref: "#lg4",
    y1: -400.863,
    y2: -392.195
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.834,
    x2: 258.443,
    y1: 375.315,
    y2: 485.858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.556,
    x2: 305.672,
    xlinkHref: "#lg1",
    y1: 255.759,
    y2: -312.878
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.664,
    x2: 299.555,
    xlinkHref: "#lg1",
    y1: 270.354,
    y2: -201.089
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.745,
    x2: 448.146,
    xlinkHref: "#lg5",
    y1: 99.942,
    y2: 139.342
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.008,
    x2: 400.52,
    xlinkHref: "#lg5",
    y1: 151.591,
    y2: 169.103
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.196,
    x2: 46.708,
    xlinkHref: "#lg5",
    y1: 304.369,
    y2: 321.881
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.084,
    x2: 484.596,
    xlinkHref: "#lg5",
    y1: 279.977,
    y2: 297.489
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.931,
    x2: 359.443,
    xlinkHref: "#lg5",
    y1: 65.263,
    y2: 82.776
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.85,
    x2: 205.362,
    xlinkHref: "#lg5",
    y1: 98.095,
    y2: 115.607
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 427.542,
    y2: 531.049
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 38.963c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.615-47.544 2.427-47.544 26.83v403.647c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-403.65c0-24.583-27.011-39.597-47.889-26.618z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 289.143v178.182c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-178.182z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m333.692 387.483c-2.607-14.964-16.85-24.98-31.813-22.371-9.133 1.591-31.447 3.441-52.771-.101-9.836-1.634-14.203-13.179-8.239-21.17.044-.059.089-.119.133-.179 10.089-13.635 13.195-30.469 9.231-50.032-1.372-6.766-7.969-11.141-14.733-9.769-5.031 1.019-8.733 4.929-9.741 9.648-3.439-1.444-6.39-3.318-7.696-5.626-1.877-3.313.136-8.704 2.155-12.643 3.149-6.143.722-13.677-5.422-16.826-6.139-3.15-13.677-.723-16.826 5.421-8.74 17.051-5.728 29.188-1.661 36.368 6.424 11.342 18.982 16.8 28.796 19.408.118.031.232.059.349.09-.987 3.268-2.473 6.265-4.484 9.004-4.026 5.481-9.679 9.398-15.361 12.182-2.486-4.339-4.184-9.306-5.155-15.049-2.527-14.943-16.613-25.431-31.575-23.014-10.675 1.725-18.905 9.377-21.894 19.046-4.683-2.703-8.997-6.233-12.118-10.859-2.32-3.44-3.84-7.393-4.596-11.821 2.754-.115 5.983-.376 9.464-.908 14.063-2.15 25.268-7.747 32.402-16.186 11.351-13.426 10.057-30.596 6.972-42.634-1.714-6.688-8.523-10.722-15.212-9.007-6.687 1.713-10.72 8.524-9.006 15.211 2.356 9.197 1.745 16.012-1.818 20.255-4.397 5.237-13.189 7.331-20.328 8.041.436-1.46.901-2.938 1.43-4.453 2.278-6.517-1.157-13.647-7.674-15.926-6.524-2.271-13.647 1.157-15.925 7.675-3.156 9.027-5.041 17.539-5.669 25.514-3.01-.432-6.151-1.399-8.93-3.295-5.949-4.06-9.558-12.071-10.724-23.806-.688-6.869-6.806-11.885-13.675-11.202-6.87.683-11.886 6.806-11.202 13.675.325 3.269.8 6.39 1.424 9.355 3.114 14.808 9.94 25.82 20.361 32.813 8.591 5.765 17.869 7.558 25.576 7.759 1.566 4.624 3.728 8.98 6.495 13.055 7.672 11.299 20.015 19.993 35.808 25.268 6.402 19.452 18.302 35.724 35.022 47.61 11.235 7.986 24.467 14.004 39.582 18.021 13.02 3.46 27.438 5.435 43.171 5.904 23.97.712 42.719-2.498 43.506-2.636 14.962-2.605 24.978-16.848 22.371-31.81z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.095 454.158c14.375 4.908 30.005-2.765 34.91-17.14 4.158-12.175 20.083-46.85 42.81-63.551.591 6.751 2.156 13.742 5.267 20.484 7.106 15.402 20.373 26.219 39.433 32.148 6.592 2.05 13.601-1.631 15.649-8.222 1.525-4.901-.123-10.028-3.776-13.18 2.92-2.321 5.982-4.007 8.633-4.044 3.807-.053 7.567 4.304 10.05 7.968 3.873 5.715 11.645 7.209 17.36 3.335 5.714-3.869 7.209-11.645 3.336-17.36-10.748-15.862-22.839-19.055-31.09-18.941-13.034.18-23.857 8.567-30.862 15.918-.084.088-.163.175-.246.263-2.391-2.437-4.305-5.181-5.739-8.261-2.87-6.166-3.588-13.005-3.297-19.326 5.09-.095 10.357.838 15.971 2.819 14.322 5.053 30.03-2.462 35.083-16.783 3.589-10.173.833-21.041-6.195-28.297 4.621-2.806 9.791-4.892 15.348-5.405 4.132-.381 8.329.187 12.575 1.653-1.223 2.47-2.547 5.427-3.754 8.735-4.876 13.365-5.355 25.88-1.386 36.193 6.316 16.408 21.992 23.528 34.031 26.611 6.688 1.713 13.499-2.318 15.211-9.008 1.713-6.687-2.32-13.497-9.007-15.21-9.197-2.356-14.879-6.168-16.886-11.332-2.478-6.373-.087-15.089 2.722-21.69 1.071 1.084 2.143 2.202 3.217 3.395 4.619 5.131 12.523 5.546 17.654.928 5.127-4.629 5.546-12.523.927-17.654-18.157-20.169-37.59-29.422-57.76-27.501-13.596 1.295-27.153 7.938-39.372 19.25-20.134-3.738-40.123-1.127-58.584 7.819-12.404 6.012-24.043 14.721-34.832 26.043-9.294 9.753-17.957 21.445-25.932 35.016-12.149 20.675-18.348 38.659-18.605 39.415-4.911 14.375 2.763 30.005 17.136 34.912z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.896 170.514c-2.838-6.294-10.242-9.098-16.533-6.258-6.293 2.838-9.095 10.24-6.257 16.533.814 1.805 1.489 3.574 2.033 5.311-5.527-1.813-11.335-4.735-14.38-9.263-1.153-1.715-4.663-6.934-.307-19.623 2.242-6.529-1.235-13.64-7.764-15.882-6.53-2.238-13.64 1.236-15.881 7.765-6.936 20.204-2.084 33.823 3.208 41.691 8.251 12.269 22.038 17.974 32.472 20.619-9.555 16.185-32.766 26.96-41.505 29.902-6.54 2.185-10.077 9.253-7.902 15.798 1.742 5.244 6.623 8.562 11.86 8.562 1.307 0 2.636-.206 3.944-.641 1.8-.599 44.257-15.021 58.352-47.172 6.544-14.928 6.094-30.857-1.34-47.342z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.592 226.683c4.92-4.844 12.837-4.784 17.677.137 4.843 4.92 4.781 12.834-.138 17.677-1.411 1.389-2.68 2.794-3.815 4.218 5.809.306 12.28-.321 16.756-3.443 1.695-1.182 6.853-4.781 7.375-18.187.268-6.898 6.079-12.272 12.977-12.005 6.897.272 12.272 6.08 12.004 12.977-.832 21.345-10.275 32.292-18.052 37.717-12.126 8.46-27.043 8.799-37.728 7.496 3.063 18.544 20.814 36.976 27.9 42.876 5.309 4.399 6.054 12.268 1.662 17.586-3.519 4.261-9.268 5.591-14.152 3.699-1.218-.472-2.383-1.144-3.446-2.022-1.462-1.209-35.842-29.995-37.371-65.066-.71-16.283 5.464-30.974 18.351-43.66z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m268.096 304.193c-3.146-6.145-10.679-8.577-16.823-5.431-.131.067-13.332 6.782-30.529 11.84-21.454 6.31-38.894 7.103-50.434 2.292-7.941-3.311-13.019-9.19-15.98-18.506-2.092-6.58-9.122-10.213-15.699-8.127-6.579 2.092-10.217 9.12-8.126 15.699 2.135 6.716 5.199 12.66 9.085 17.765-4.86 4.663-11.71 9.615-18.575 9.969-5.56.276-10.997-2.635-16.61-8.934-4.593-5.153-12.494-5.608-17.648-1.016-5.154 4.593-5.609 12.494-1.016 17.648 12.532 14.063 25.369 17.318 34.565 17.318.742 0 1.461-.021 2.154-.06 16.41-.911 29.469-11.572 36.864-19.298.456.205.904.421 1.368.614 8.043 3.353 17.289 5.028 27.671 5.028 11.726 0 24.902-2.138 39.435-6.411 19.424-5.712 34.247-13.253 34.868-13.57 6.145-3.143 8.576-10.675 5.43-16.82z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.47 433.323c-3.479 0-7.017-.664-10.435-2.067-14.029-5.761-20.744-21.786-15.02-35.821.227-.565 12.53-31.56 15.362-74.001 3.673-55.045-9.545-102.939-39.286-142.354-9.148-12.124-6.736-29.368 5.388-38.517 12.125-9.147 29.369-6.735 38.516 5.388 37.792 50.085 55.122 112.743 50.117 181.201-3.726 50.957-18.563 87.575-19.192 89.108-4.365 10.633-14.628 17.063-25.45 17.063z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.857 295.903c-.364-.162-36.575-16.982-42.974-45.225-1.932-8.525-.954-17.554 2.89-27.008.016-.039.036-.076.052-.115.01-.026.017-.052.027-.078 3.22-7.844 8.409-15.979 15.565-24.362 4.482-5.251 3.859-13.141-1.392-17.623-5.249-4.479-13.14-3.858-17.623 1.393-5.287 6.193-9.754 12.373-13.402 18.528-.906-.693-1.809-1.436-2.676-2.239-7.761-7.189-5.769-12.158-4.812-14.546 2.57-6.407-.542-13.685-6.949-16.254-6.409-2.573-13.686.542-16.254 6.949-6.132 15.29-2 30.472 11.635 42.747 3.042 2.739 6.208 5.009 9.095 6.836-2.679 10.565-2.868 21.015-.539 31.296 9.241 40.787 55.24 61.674 57.194 62.543 1.651.734 3.376 1.082 5.074 1.082 4.787 0 9.356-2.766 11.428-7.422 2.807-6.307-.031-13.695-6.339-16.502z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.616 353.29c-20.56 0-35.153-2.139-35.913-2.253-15.021-2.246-25.376-16.244-23.129-31.265 2.244-15.008 16.221-25.355 31.223-23.137 19.736 2.869 77.679 4.994 108.574-19.283 12.753-10.021 19.797-23.82 21.534-42.185 1.43-15.12 14.836-26.207 29.967-24.789 15.12 1.43 26.218 14.847 24.789 29.967-3.15 33.308-17.843 61.108-42.491 80.397-24.113 18.87-57.019 29.657-97.802 32.061-5.884.347-11.513.487-16.752.487z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.774 220.966c-1.471-6.729-8.132-10.997-14.863-9.545-.294.063-29.561 6.164-45.812-8.018-3.126-2.728-5.611-6.159-7.478-10.244 2.632-.819 5.686-1.9 8.913-3.309 13.039-5.69 22.43-13.978 27.157-23.966 7.521-15.892 1.86-32.152-4.213-42.994-3.374-6.023-10.991-8.172-17.015-4.797-6.023 3.373-8.17 10.991-4.797 17.014 4.64 8.283 5.799 15.026 3.446 20.042-2.904 6.19-10.863 10.472-17.58 12.993.046-1.523.116-3.071.239-4.671.528-6.884-4.624-12.892-11.507-13.42-6.889-.514-12.892 4.625-13.419 11.508-2.075 27.059 4.633 47.51 19.939 60.786 10.936 9.486 26.19 14.801 44.114 15.369 1.099.035 2.175.051 3.229.051 11.316 0 19.775-1.845 20.162-1.931 6.726-1.491 10.957-8.139 9.485-14.868z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.842 281.833c-15.64 0-29.974-2.417-42.883-7.249-24.266-9.084-42.927-26.875-53.965-51.452-6.223-13.854-.036-30.13 13.819-36.353 13.854-6.222 30.13-.036 36.353 13.819 5.097 11.349 12.43 18.49 23.075 22.476 28.334 10.604 72.076-4.249 85.167-10.287 13.791-6.364 30.128-.344 36.492 13.448 6.363 13.79.342 30.128-13.449 36.491-.725.335-18.02 8.254-41.369 13.723-15.327 3.589-29.769 5.384-43.24 5.384z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.748 100.358c-2.838-6.294-10.24-9.097-16.533-6.258-6.293 2.838-9.095 10.24-6.257 16.533.814 1.805 1.489 3.574 2.033 5.311-5.527-1.813-11.335-4.735-14.38-9.263-1.153-1.715-4.663-6.934-.307-19.623 2.242-6.529-1.235-13.64-7.764-15.882-6.529-2.237-13.64 1.235-15.881 7.765-6.936 20.204-2.084 33.823 3.208 41.691 8.251 12.269 22.038 17.974 32.472 20.619-9.555 16.185-32.766 26.96-41.505 29.902-6.54 2.185-10.077 9.253-7.902 15.798 1.742 5.244 6.623 8.562 11.86 8.562 1.307 0 2.636-.206 3.944-.641 1.8-.599 44.257-15.021 58.352-47.172 6.544-14.928 6.094-30.856-1.34-47.342z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.13 156.97c-3.063-6.187-10.563-8.721-16.748-5.656-4.6 2.277-7.174 7.007-6.936 11.826-3.695-.512-7.028-1.566-8.883-3.46-2.665-2.72-2.104-8.447-1.165-12.772 1.465-6.746-2.815-13.403-9.562-14.868-6.745-1.467-13.403 2.814-14.869 9.562-4.067 18.724 1.962 29.68 7.736 35.574 9.122 9.312 22.66 11.36 32.815 11.36.122 0 .24-.002.36-.003-.114 3.412-.78 6.69-2.021 9.854-7.153 18.238-30.673 27.42-31.075 27.574-6.445 2.424-9.719 9.606-7.314 16.063 1.875 5.031 6.645 8.14 11.715 8.14 1.45 0 2.924-.254 4.362-.789 1.389-.518 34.152-13.004 45.515-41.68 6.25-15.77 4.927-32.837-3.93-50.725z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.421 271.161c-.832 0-1.375-.016-1.576-.022-6.899-.241-12.296-6.03-12.055-12.93.241-6.887 6.012-12.309 12.894-12.056.118.001 6.938.171 14.852-1.536 6.287-1.355 14.67-4.205 18.906-10.078 4.193-5.814 4.107-14.818-.255-26.76-2.369-6.484.968-13.662 7.452-16.03 6.484-2.366 13.662.967 16.03 7.452 7.4 20.258 6.383 37.101-3.022 50.06-7.149 9.851-19.1 16.749-34.559 19.946-8.375 1.733-15.547 1.954-18.667 1.954z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.819 304.685c4.832 4.623 12.498 4.454 17.121-.379 4.623-4.832 4.454-12.498-.379-17.121-4.832-4.623-21.575 12.877-16.742 17.5z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.974 332.863c-.63 6.658 4.257 12.566 10.915 13.196s12.566-4.257 13.196-10.915-23.481-8.939-24.111-2.281z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.55 291.796c-1.663-6.478 2.24-13.077 8.718-14.74s13.077 2.24 14.74 8.718-21.795 12.5-23.458 6.022z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.962 306.172c-1.663-6.478 2.24-13.077 8.718-14.74s13.077 2.24 14.74 8.718-21.795 12.5-23.458 6.022z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.02 240.243c-5.585-3.679-7.131-11.189-3.452-16.774s11.189-7.131 16.774-3.452c5.585 3.678-7.737 23.904-13.322 20.226z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m476.65 249.26c-6.9 9.5-18.27 16.24-32.94 19.58-6.95 20.77-19.31 38.42-36.54 51.9-24.11 18.87-57.02 29.66-97.8 32.06-5.89.35-11.52.49-16.75.49-2.59 0-5.08-.03-7.46-.09-5.67 36.97-15.72 61.8-16.24 63.06-4.37 10.63-14.63 17.06-25.45 17.06-3.48 0-7.02-.66-10.43-2.06-1.8-.74-3.48-1.64-5.02-2.7 4.33-2.92 7.87-7.1 10-12.3.63-1.53 15.46-38.15 19.19-89.11 5.01-68.46-12.32-131.11-50.12-181.2-1.86-2.47-4.07-4.54-6.49-6.19 12.04-8.18 28.53-5.56 37.4 6.19 3.48 4.62 6.78 9.34 9.92 14.17 7.54-4.95 14.96-11.32 19.42-18.87-10.44-2.64-24.22-8.35-32.47-20.62-5.3-7.87-10.15-21.48-3.21-41.69 2.24-6.53 9.35-10 15.88-7.76s10 9.35 7.76 15.88c-4.35 12.69-.84 17.91.31 19.62 3.05 4.53 8.85 7.45 14.38 9.27-.54-1.74-1.22-3.51-2.03-5.32-2.84-6.29-.04-13.69 6.25-16.53 6.3-2.84 13.7-.04 16.54 6.26 7.43 16.48 7.88 32.41 1.34 47.34-6.65 15.17-19.61 26.39-31.64 34.07 17.97 35.01 27.6 74.42 28.43 116.54 14.25.17 31.63-.9 48.09-4.8-9.47-9.67-18.02-22.1-21.47-37.31-2.33-10.28-2.14-20.73.54-31.29-2.89-1.83-6.05-4.1-9.1-6.84-13.63-12.28-17.76-27.46-11.63-42.75 2.57-6.4 9.85-9.52 16.25-6.95 6.41 2.57 9.52 9.85 6.95 16.26-.95 2.39-2.95 7.35 4.81 14.54.87.81 1.78 1.55 2.68 2.24 3.65-6.15 8.12-12.33 13.4-18.53 4.49-5.25 12.38-5.87 17.63-1.39s5.87 12.37 1.39 17.63c-7.16 8.38-12.35 16.51-15.57 24.36-.01.02-.01.05-.02.08-.02.03-.04.07-.06.11-3.84 9.45-4.82 18.48-2.89 27.01 3.19 14.08 13.79 25.32 23.67 33.07 3.49-1.9 6.79-4.02 9.82-6.4 12.75-10.02 19.8-23.82 21.53-42.18 1.43-15.12 14.84-26.21 29.97-24.79 15.1 1.43 26.19 14.81 24.8 29.9 2.66-1.49 5.06-3.36 6.77-5.74 4.19-5.82 4.11-14.82-.25-26.76-2.37-6.49.96-13.66 7.45-16.03 6.48-2.37 13.66.97 16.03 7.45 7.4 20.26 6.38 37.1-3.02 50.06z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m151.085 264.167c-2.787 6.08-9.975 8.748-16.055 5.961s-8.748-9.975-5.961-16.055 24.803 4.015 22.016 10.094z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.711 253.68c3.04 5.957.676 13.251-5.281 16.291s-13.251.676-16.291-5.281 18.532-16.967 21.572-11.01z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.939 241.424c-.843-6.635-6.904-11.33-13.539-10.487s-11.33 6.904-10.487 13.539c.843 6.634 24.869 3.582 24.026-3.052z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.369 213.956c3.835-5.479 2.503-13.03-2.976-16.865s-13.03-2.503-16.865 2.976 16.006 19.368 19.841 13.889z",
    fill: "url(#SVGID_25_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m477.585 415.881c-109.919-56.442-335.251-56.442-445.17 0-19.963 10.25-32.415 30.909-32.415 53.35 0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4 0-22.441-12.452-43.1-32.415-53.35z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 76.611c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.887-12.615 47.543 2.427 47.543 26.83v365.999c0 11.267-9.133 20.4-20.4 20.4h-469.2c-11.267 0-20.4-9.133-20.4-20.4v-366.002c0-24.583 27.011-39.597 47.889-26.618z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 155.611c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v286.999c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-287.002c0-24.584 27.011-39.598 47.889-26.619z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 420.3,
    cy: 111.496,
    fill: "url(#SVGID_29_)",
    r: 28.125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.175,
    cy: 160.757,
    fill: "url(#SVGID_30_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.362,
    cy: 313.535,
    fill: "url(#SVGID_31_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.25,
    cy: 289.143,
    fill: "url(#SVGID_32_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.098,
    cy: 74.43,
    fill: "url(#SVGID_33_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.016,
    cy: 107.262,
    fill: "url(#SVGID_34_)",
    r: 16.305
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 397.458v71.773c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-71.773z",
    fill: "url(#SVGID_35_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoralReef);
export default __webpack_public_path__ + "static/media/icon-coral-reef.96c2d34a05a764f4f268c0d40d66f19a.svg";
export { ForwardRef as ReactComponent };